export const DELIVERY_NOTE_EXPORT = {
    REQUEST: 'DELIVERY_NOTE_EXPORT.REQUEST',
    SUCCESS: 'DELIVERY_NOTE_EXPORT.SUCCESS',
    FAILED: 'DELIVERY_NOTE_EXPORT.FAILED',
};
